// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-bar {
  width: 64px;
  height: 93vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid var(--300-grey, #DFE4EB);
  background: var(--white, #FFF);
  color: var(--600-grey, #929FB0);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 115%;
  /* 11.5px */
}
.left-bar .icon {
  cursor: pointer;
  width: 64px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.left-bar .icon svg {
  margin-bottom: 6px;
}
.left-bar .icon svg path {
  stroke: #929FB0;
}
.left-bar .icon:hover {
  color: #355C7D;
  background: #D0E8FD;
  border-radius: 10px;
}
.left-bar .icon:hover svg path {
  stroke: #355C7D;
}
.left-bar .icon-container > * {
  flex: 1 1;
  width: 100%;
  box-sizing: border-box;
}
.left-bar .icon-container > *:first-of-type .partial-border, .left-bar .icon-container > *:last-of-type .partial-border {
  width: 60%;
  height: 70px;
  margin: auto;
}
.left-bar .icon-container > *:first-of-type .partial-border {
  border-top: 1px solid #e5e5e5;
}
.left-bar .icon-container > *:last-of-type .partial-border {
  border-bottom: 1px solid #e5e5e5;
}
.left-bar .user-icon-container {
  border-radius: 6px 6px 0px 0px;
  background: var(--gray-100, #F9FAFB);
}
.left-bar .link-active {
  background: #D0E8FD;
  border-radius: 10px;
  color: #355C7D;
}
.left-bar .link-active .award,
.left-bar .link-active .brief,
.left-bar .link-active .icon-logout {
  background-color: #355C7D;
}
.left-bar .link-active svg path {
  stroke: #355C7D;
}
.left-bar .link-active span {
  color: #355C7D !important;
}`, "",{"version":3,"sources":["webpack://./src/components/LeftBar/LeftBar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EAEA,gDAAA;EACA,8BAAA;EAEA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAFF;AAIE;EACE,eAAA;EAEA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;AAMI;EACE,kBAAA;AAJN;AAMM;EACE,eAAA;AAJR;AAQI;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;AANN;AASQ;EACE,eAAA;AAPV;AAcI;EACE,SAAA;EAEA,WAAA;EACA,sBAAA;AAbN;AAiBQ;EACE,UAAA;EACA,YAAA;EACA,YAAA;AAfV;AAoBQ;EACE,6BAAA;AAlBV;AAuBQ;EACE,gCAAA;AArBV;AA2BE;EACE,8BAAA;EACA,oCAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;AA1BJ;AA4BI;;;EAGE,yBAAA;AA1BN;AA8BM;EACE,eAAA;AA5BR;AAgCI;EACE,yBAAA;AA9BN","sourcesContent":[".left-bar {\n  width: 64px;\n  height: 93vh;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  border-right: 1px solid var(--300-grey, #DFE4EB);\n  background: var(--white, #FFF);\n\n  color: var(--600-grey, #929FB0);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 115%;\n  /* 11.5px */\n\n  .icon {\n    cursor: pointer;\n\n    width: 64px;\n    height: 64px;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      margin-bottom: 6px;\n\n      path {\n        stroke: #929FB0;\n      }\n    }\n\n    &:hover {\n      color: #355C7D;\n      background: #D0E8FD;\n      border-radius: 10px;\n\n      svg {\n        path {\n          stroke: #355C7D;\n        }\n      }\n    }\n  }\n\n  .icon-container {\n    >* {\n      flex: 1;\n\n      width: 100%;\n      box-sizing: border-box;\n\n      &:first-of-type,\n      &:last-of-type {\n        .partial-border {\n          width: 60%;\n          height: 70px;\n          margin: auto;\n        }\n      }\n\n      &:first-of-type {\n        .partial-border {\n          border-top: 1px solid #e5e5e5;\n        }\n      }\n\n      &:last-of-type {\n        .partial-border {\n          border-bottom: 1px solid #e5e5e5;\n        }\n      }\n    }\n  }\n\n  .user-icon-container {\n    border-radius: 6px 6px 0px 0px;\n    background: var(--gray-100, #F9FAFB);\n  }\n\n  .link-active {\n    background: #D0E8FD;\n    border-radius: 10px;\n    color: #355C7D;\n\n    .award,\n    .brief,\n    .icon-logout {\n      background-color: #355C7D;\n    }\n\n    svg {\n      path {\n        stroke: #355C7D;\n      }\n    }\n\n    span {\n      color: #355C7D !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
